import React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Grid } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  mainContent: {
    [theme.breakpoints.up('md')]: {
      paddingRight: theme.spacing(3)
    }
  },
  sidebar: {
    position: 'sticky',
    top: theme.spacing(2),
    alignSelf: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      marginTop: theme.spacing(3)
    }
  },
  heroDivider: {
    margin: theme.spacing(4, 0),
    backgroundColor: theme.palette.divider,
    height: '2px'
  }
}));

const JobGeneralPublicView = ({
  headerSection,
  jobSection,
  companySection,
  sidebarSection
}) => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="lg">
      {/* Header Section */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box className={classes.contentHeader}>
            {typeof headerSection === 'function'
              ? headerSection()
              : headerSection}
          </Box>
        </Grid>
      </Grid>

      {/* Company Banner Section (full width) */}
      {companySection && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {typeof companySection === 'function'
              ? companySection()
              : companySection}
          </Grid>
        </Grid>
      )}
      {/* Hero Section Divider */}
      <Grid item style={{ width: '100%' }}>
        <Divider className={classes.heroDivider} />
      </Grid>
      {/* Main Content with Sidebar Layout */}
      <Grid container spacing={3}>
        {/* Left Column - Job Content */}
        <Grid item xs={12} md={8} className={classes.mainContent}>
          {typeof jobSection === 'function' ? jobSection() : jobSection}
        </Grid>

        {/* Right Column - Sidebar */}
        {sidebarSection && (
          <Grid item xs={12} md={4} className={classes.sidebar}>
            {typeof sidebarSection === 'function'
              ? sidebarSection()
              : sidebarSection}
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

JobGeneralPublicView.defaultProps = {
  sidebarSection: null,
  companySection: null
};

JobGeneralPublicView.propTypes = {
  headerSection: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
    .isRequired,
  jobSection: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  companySection: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  sidebarSection: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
};

export default JobGeneralPublicView;
